import React, { useEffect, useState } from 'react';
import Header from '../../Layout/Header';
import useOmega3Purchase from './hooks/useOmega3Purchase';
import Omega3PromoBar from './components/Omega3PromoBar';
import Omega3Hero from './components/Omega3Hero';
import Omega3PlanSelector from './components/Omega3PlanSelector';
import Omega3Reviews from './components/Omega3Reviews';
import Omega3Faq from './components/Omega3Faq';
import Omega3StickyCta from './components/Omega3StickyCta';
import Omega3DifferenceSection from './components/Omega3DifferenceSection';
import Omega3BenefitsSection from './components/Omega3BenefitsSection';
import Omega3HowToSection from './components/Omega3HowToSection';
import Omega3IngredientsSection from './components/Omega3IngredientsSection';

const Omega3Page = () => {
  const { isLoading, plans, selectedPlan, selectedPlanKey, setSelectedPlanKey, startCheckout } =
    useOmega3Purchase();
  const [showStickyCta, setShowStickyCta] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowStickyCta(window.scrollY > 700);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header />
      <Omega3PromoBar messageKey="Omega3_Product_Promo_Message" />
      {/* <div className="t-sticky t-top-0 t-z-30 t-overflow-hidden t-bg-navy t-py-2.5 t-text-white">
        <div className="t-flex t-min-w-max t-gap-16 t-whitespace-nowrap t-text-[13px] t-font-semibold">
          <span>{t('Omega3_Topbar_Line')}</span>
          <span>{t('Omega3_Topbar_Line')}</span>
        </div>
      </div> */}
      <Omega3Hero>
        <Omega3PlanSelector
          plans={plans}
          selectedPlanKey={selectedPlanKey}
          onSelect={setSelectedPlanKey}
          onCheckout={startCheckout}
          checkoutDisabled={isLoading || !selectedPlan?.paymentLink}
        />
      </Omega3Hero>
      <Omega3DifferenceSection />
      <Omega3BenefitsSection />
      <Omega3HowToSection />
      <Omega3IngredientsSection />
      <Omega3Reviews />
      <Omega3Faq />
      <Omega3StickyCta
        selectedPlan={selectedPlan}
        onCheckout={startCheckout}
        hidden={!showStickyCta || isLoading || !selectedPlan?.paymentLink}
      />
    </>
  );
};

export default Omega3Page;
